"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DizzyEffectHandler = exports.DizzyEffectArgs = void 0;
const core_1 = require("../../event-handlers/core");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class DizzyEffectArgs {
    constructor(attackCount) {
        this.attackCount = attackCount;
        this.__type = EffectType_1.EffectType.Dizzy;
        this.__typeName = "Dizzy";
        this.name = "Dizzy";
        this.harmful = true;
    }
}
exports.DizzyEffectArgs = DizzyEffectArgs;
let DizzyEffectHandler = class DizzyEffectHandler {
    apply(sequence, container, state) {
        state.meta.ehId = container.registerEventHandler(state.targetId, EventType_1.EventType.Attack, Schedule_1.Schedule.LimitedEmissions(state.args.attackCount), new core_1.CancelEffectsEventHandlerArgs([state.id]));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.ehId);
    }
};
DizzyEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Dizzy)
], DizzyEffectHandler);
exports.DizzyEffectHandler = DizzyEffectHandler;
